import type { UserProfile } from '../types/external'

const ADMIN_ROLES = new Set(['ADMIN', 'SUPER_ADMIN', 'ACCOUNT_EXECUTIVE'])

export const isAdminRole = (user: UserProfile | undefined) =>
  (user?.roles ?? []).some(role => ADMIN_ROLES.has(role))
